import { ReactNode } from 'react'
import {
  Box,
  Button,
  Divider,
  Grid,
  SxProps,
  Tooltip,
  Typography,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { ListViewProvider } from '../../contexts/ListViewContext'

interface ListPageProps {
  title?: string
  children: ReactNode
  toolbar?: ReactNode
  search?: ReactNode
  color?: string
  onCreate?: () => void
  isBanner: boolean
  divider?: boolean
}

export const ListPage = ({
  title,
  children,
  toolbar,
  search,
  color,
  onCreate,
  isBanner,
  divider = true,
}: ListPageProps) => {
  const style: SxProps = isBanner
    ? {
        height: '6rem',
        maxWidth: { xs: '100%', md: 'calc(100% - 15rem)' },
        justifyContent: 'space-between',
        position: 'fixed',
        top: { xs: '6rem', md: 0 },
        p: 3,
        px: 4,
        zIndex: 100,
        elevation: 0,
        bgcolor: 'background.default',
      }
    : {
        height: '6rem',
        justifyContent: 'space-between',
        bgcolor: 'background.default',
        p: 2,
      }

  color = color || '#424F76'

  return (
    <ListViewProvider>
      <Box>
        <Grid container sx={style} alignItems='center' justifyContent='space-between'>
          <Grid item>
            {divider && (
              <Divider color={color} sx={{ height: 6, width: '4rem' }} />
            )}
            <Typography component='h2' variant='h3' pt={2}>
              {title}
            </Typography>
          </Grid>
          <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {toolbar}
            {onCreate && (
              <Tooltip title='Nýskrá'>
                <Button
                  variant='contained'
                  startIcon={<AddIcon />}
                  onClick={onCreate}
                >
                  Nýskrá
                </Button>
              </Tooltip>
            )}
          </Grid>
        </Grid>
        <Grid item md={12} m={2} mt={isBanner ? '5.5rem' : '0rem'}>
          <Grid>{search}</Grid>
        </Grid>
        <Grid item m={2}>
          {children}
        </Grid>
      </Box>
    </ListViewProvider>
  )
}
